import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState, useCallback } from "react";
import { Flex } from "@base-ui";
import { FadedBackground, StyledPopup } from "./styles";
import { useClickOutside } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DialogAligner = function DialogAligner() {
  var ref = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    content = _useState2[0],
    setContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var open = function open(e) {
    setIsOpen(true);
    setContent(e.detail);
  };
  var close = function close() {
    setIsOpen(false);
    setContent(null);
  };
  var handleAbort = useCallback(function () {
    var _document$getElementB, _content$callback;
    (_document$getElementB = document.getElementById(content.prevId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
    (_content$callback = content.callback) === null || _content$callback === void 0 ? void 0 : _content$callback.call(content);
    close();
  }, [content]);
  useClickOutside(ref, handleAbort, isOpen);
  useEffect(function () {
    window.addEventListener("openPopup", open);
    window.addEventListener("closePopup", close);
    return function () {
      var _window, _window2;
      (_window = window) === null || _window === void 0 ? void 0 : _window.removeEventListener("closePopup", close);
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.removeEventListener("openPopup", open);
    };
  }, []);
  return isOpen && /*#__PURE__*/_jsxs(Flex.Row, {
    style: {
      zIndex: "99",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    children: [/*#__PURE__*/_jsx(FadedBackground, {}), /*#__PURE__*/_jsx(StyledPopup, {
      ref: ref,
      role: "dialog",
      "aria-labelledby": "dialog-title",
      "aria-modal": "true",
      "aria-hidden": !isOpen,
      children: content.C()
    })]
  });
};